<template>
	<div class="job-manage">
		<div class="filter-bar">
			<el-button type="primary" @click="createJob">创建岗位</el-button>
			<div class="filters">
				<el-input
					v-model="filters.companyName"
					placeholder="公司名称"
					style="width: 150px; margin-right: 10px"
				/>
				<el-input v-model="filters.jobName" placeholder="岗位名称" style="width: 150px; margin-right: 10px" />
				<el-select v-model="filters.status" placeholder="状态" style="width: 120px; margin-right: 10px">
					<el-option label="全部状态" value="" />
					<el-option label="已上架" value="1" />
					<el-option label="已下架" value="0" />
				</el-select>
				<el-button @click="fetchJobs" type="primary">搜索</el-button>
			</div>
		</div>
		<el-table :data="jobList" stripe style="width: 100%">
			<el-table-column prop="id" label="ID" width="80" />
			<el-table-column prop="jobName" label="岗位名称" />
			<el-table-column prop="jobDetail" label="岗位信息" width="200" />
			<el-table-column prop="createDate" label="创建时间" width="180">
				<template slot-scope="scope">
					{{ formatDate(scope.row.createDate) }}
				</template>
			</el-table-column>
			<el-table-column prop="applyCount" label="投递人数" width="100" />
			<el-table-column prop="companyName" label="所属公司" width="200" />
			<el-table-column label="关联" width="80">
				<template slot-scope="scope">
					<el-button type="text" @click="viewRelated(scope.row)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column label="状态" width="100">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
						{{ scope.row.status === 1 ? "已上架" : "已下架" }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="250" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" @click="editJob(scope.row)">编辑</el-button>
					<el-button type="text" @click="toggleStatus(scope.row)">
						{{ scope.row.status === 1 ? "下架" : "上架" }}
					</el-button>
					<el-button type="text" @click="deleteJob(scope.row)">删除</el-button>
					<el-button type="text" @click="viewApplications(scope.row)">投递详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			@current-change="fetchJobs"
			:current-page.sync="pagination.pageNum"
			:page-size="pagination.pageSize"
			:total="pagination.total"
			layout="prev, pager, next"
		/>
		<ApplicationDrawer v-model="showDrawer" :jobId="currentJobId" />
		<ActivitySelectDialog v-model="showActivityDialog" :jobId="currentJobIdForActivity" />
	</div>
</template>

<script>
import { jobRecruit } from "@/services";
import ApplicationDrawer from "@/components/recruit/ApplicationDrawer";
import ActivitySelectDialog from "./ActivitySelectDialog";

export default {
	name: "JobManage",
	components: {
		ApplicationDrawer,
		ActivitySelectDialog,
	},
	data() {
		return {
			filters: {
				companyName: "",
				jobName: "",
				status: "",
			},
			jobList: [],
			pagination: {
				pageNum: 1,
				pageSize: 10,
				total: 0,
			},
			showDrawer: false,
			currentJobId: null,
			showActivityDialog: false,
			currentJobIdForActivity: null,
		};
	},
	mounted() {
		this.fetchJobs();
	},
	methods: {
		async fetchJobs() {
			const params = {
				pageNum: this.pagination.pageNum,
				pageSize: this.pagination.pageSize,
				companyName: this.filters.companyName,
				jobName: this.filters.jobName,
				status: this.filters.status,
			};
			const { ok, data } = await jobRecruit.pageList(params);
			if (ok) {
				this.jobList = data.data.list;
				this.pagination.total = data.data.total || 0;
			}
		},
		createJob() {
			// 跳转到创建岗位页面
			this.$router.push("/recruitManage/create");
		},
		formatDate(timestamp) {
			if (!timestamp) return "";
			return new Date(timestamp).toLocaleString("zh-CN");
		},
		viewRelated(row) {
			this.currentJobIdForActivity = row.id;
			this.showActivityDialog = true;
		},
		editJob(row) {
			this.$router.push({
				name: "createJob",
				query: {
					id: row.id,
				},
			});
		},
		toggleStatus(row) {
			const isDown = row.status === 1;
			const newStatus = isDown ? 0 : 1;
			if (isDown) {
				// 下架需要确认
				this.$confirm("下架后，该岗位不显示在直播或活动页中，是否确认下架？", "确认要下架该岗位吗", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						this.updateStatus(row.id, newStatus);
					})
					.catch(() => {
						// 取消
					});
			} else {
				// 上架直接执行
				this.updateStatus(row.id, newStatus);
			}
		},
		updateStatus(id, status) {
			jobRecruit
				.updateStatus(id, status)
				.then(({ ok }) => {
					if (ok) {
						this.$message.success("操作成功");
						this.fetchJobs();
					}
				})
				.catch(() => {
					this.$message.error("操作失败");
				});
		},
		deleteJob(row) {
			this.$confirm(
				"是否确认删除？若岗位关联直播间，删除后，用户上传该岗位的附件也会消失",
				"确认要删除该岗位吗？",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			)
				.then(() => {
					jobRecruit
						.deleteJob(row.id)
						.then(({ ok }) => {
							if (ok) {
								this.$message.success("删除成功");
								this.fetchJobs();
							}
						})
						.catch(() => {
							this.$message.error("删除失败");
						});
				})
				.catch(() => {
					// 取消
				});
		},
		viewApplications(row) {
			this.currentJobId = row.id;
			this.showDrawer = true;
		},
	},
};
</script>

<style scoped>
.filter-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}

.filters {
	display: flex;
	align-items: center;
}
</style>
